import Avatar from "./Avatar";

interface TitleBarProps {
    authorName: string;
    title: string;
}

const TitleBarCaselet = ({ title, authorName }: TitleBarProps) => {
    if (authorName === "" || authorName === undefined) {
        authorName = "John Doe";
    }
    const getInitials = (name: string) => {
        return name
            .split(" ")
            .map(n => n[0])
            .join("");
    };
    const initials = getInitials(authorName);
    return (
    
        <div className=" px-4 py-2  rounded-xl  bg-white p-4 w-full shadow-lg mx-auto grid grid-cols-5 ">
            <div className=" min-w-12  flex items-center justify-start avatar-style-caselet">
                <Avatar initials={initials} className="mr-2 h-8 w-8 min-w-8 col-span-1" fullName={authorName} />
            </div>
            <div className="col-span-4 ">
                <h2 className="text-lg font-title  caselet-title-style truncate" title={title}>{title}</h2>
            </div>
        </div>
    );
};
export default TitleBarCaselet;
